<template>
  <div class="new_vip">
    <el-tabs v-model="activeName" @tab-click="setCon" style="width:900px">
      <el-tab-pane label="提成记录" name="first">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="员工姓名" width="180">
          </el-table-column>
          <el-table-column prop="name" label="手机号" width="180">
          </el-table-column>
          <el-table-column prop="name" label="充值提成" width="180">
          </el-table-column>          
          <el-table-column prop="name" label="销售提成" width="180">
          </el-table-column>
          <el-table-column prop="name" label="时间" width="180">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="提成设置" name="second">
        <el-form class="form-con" ref="form" :rules="rules" :model="form_data" label-width="80px">
          <el-form-item label="规则名称" prop="name">
            <el-input v-model="form_data.name"></el-input>
          </el-form-item>
          <el-form-item label="选择门店">
            <el-select v-model="form_data.shop" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <template>
            <el-form-item label="关联类别">
              <el-select v-model="form_data.shop" placeholder="请选择石油类别">
                <el-option label="柴油" value="shanghai"></el-option>
                <el-option label="汽油" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="油品选择">
              <el-checkbox label="全选" name="all"></el-checkbox>
              <el-checkbox-group v-model="form_data.type">
                <el-checkbox label="柴油" name="type"></el-checkbox>
                <el-checkbox label="汽油" name="type"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="提成规则">
              <div class="royalties-con">
                <div class="royalties-list">
                  <span>消费满</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">元</template>
                  </el-input>
                  <span>提成</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">%</template>
                  </el-input>
                  <span>最高</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <div class="royalties-list">
                  <span>消费满</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">元</template>
                  </el-input>
                  <span>提成</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">%</template>
                  </el-input>
                  <span>最高</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <i class="el-icon-circle-plus"></i>
              </div>
            </el-form-item>
          </template>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">创建规则</el-button>
          </el-form-item>
          <el-form-item label="充值设置">
            <el-checkbox label="全选" name="all"></el-checkbox>
            <el-checkbox-group v-model="form_data.type">
              <el-checkbox label="柴油卡" name="type"></el-checkbox>
              <el-checkbox label="汽油卡" name="type"></el-checkbox>
              <el-checkbox label="加油卡" name="type"></el-checkbox>
              <el-checkbox label="车队卡" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="提成规则">
              <div class="royalties-con">
                <div class="royalties-list">
                  <span>充值</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">元</template>
                  </el-input>
                  <span>————</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">%</template>
                  </el-input>
                  <span>提成</span>
                  <el-input class="roy-item" v-model="form_data.price">
                    <template slot="append">%</template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form_data: {
        name: "",
        shop: "",
        price: "",
        type: ['柴油', '汽油']
      },
      activeName: "first",
      rules: {
        name: [
          { required: true, message: '请输入规则名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }]
    } 
  },
  methods: {
    onSubmit(event) {
      console.log(event);
    },
    setCon(event) {
      console.log(event);
    }
  }
}
</script>
<style scoped>
.new_vip  {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
}
.form-con {
  width: 900px;
  padding: 20px;
  background-color: #fff;
}
.roy-item {
  max-width: 120px;
  height: 40px;
  margin: 0 10px;
}
.royalties-con {
  display: flex;
  margin-top: -20px;
  position: relative;
  flex-direction: column;
}
.royalties-list {
  margin-top: 20px;
}
.el-icon-circle-plus {
  font-size: 40px;
  cursor: pointer;
  position: absolute;
  right: 160px;
  top: 20px;
}
</style>